import {Component, OnInit} from '@angular/core';
import {ResourcePageState} from '../../services/resource-page-state.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  providers: [ResourcePageState],
})
export class AccessDeniedComponent implements OnInit {
  constructor(public readonly resourcePage: ResourcePageState) {}
  ngOnInit(): void { this.resourcePage.show('403'); }
}
